import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import {
    MDBBtn,
    MDBInput,
    MDBCard,
    MDBCardBody,
    MDBRow,
    MDBCol,
    MDBIcon
} from 'mdb-react-ui-kit';
import { defaultPolicyContent } from "../../utils/DefaultPolicyData"
import { updateCancellationPolicy, getCustomisableCancellation } from "../../services/apiServices.js";
import { logEvent } from "../../services/classApiServices";
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics';

function FlexibleCancellationPolicy({ toggleShow, onDetailsChange, showAlert }) {
 const { trackButtonClick } = useAnalytics();
    const [formData, setFormData] = useState({
        title: 'Terms and Conditions',
        details: defaultPolicyContent
    });

    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [apiError, setApiError] = useState(false);

    const gymId = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;


    console.log("gymId", gymId);
    const isHtmlEmpty = (html) => {
        if (!html) return true;
        const textContent = html.replace(/<[^>]*>/g, '').trim();
        return textContent === '';
    };

    useEffect(() => {
        async function fetchCancellationPolicy() {
            const response = await getCustomisableCancellation(gymId);
            if (!response || response === "false") return;

            const result = await response.json();
            console.log("Fetched Terms and Conditions:", result);
            if (result) {
                const policyDetails = result.cancellationpolicy || result.cancellationPolicy || '';

                setFormData({
                    title: result.title || 'Terms and Conditions',
                    details: isHtmlEmpty(policyDetails) ? defaultPolicyContent : policyDetails
                });
            }
        }

        fetchCancellationPolicy();
    }, [gymId]);

    useEffect(() => {
        if (onDetailsChange) {
            onDetailsChange(formData.details);
        }
    }, [formData.details, onDetailsChange]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) newErrors.title = 'Title is required';
        if (!formData.details.trim()) newErrors.details = 'Policy details are required';
        if (isHtmlEmpty(formData.details)) {
            newErrors.details = 'Policy details are required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSaveButton = async (e) => {
        e?.preventDefault();
        if (!validateForm()) return;

        setIsSaving(true);
        setApiError(false);
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo.fname && userInfo.lname
            ? `${userInfo.fname} ${userInfo.lname}`
            : userInfo.name || "User";

        const username1 = userInfo.username || userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress") || " ";
        const browserinfo = `${browserName || "Unknown"}-${browserVersion || "0"}.0.0`;

        const Eventtype = username1;
        const flag = `Terms and Conditions successfully updated(${fullName})`;
        showAlert(flag);


        const payload = {
            gymid: gymId,
            title: formData.title,
            details: formData.details
        };

        try {
            const response = await updateCancellationPolicy(payload, gymId);
            if (response.ok || response.status === 200) {
                toggleShow(false);

                await logEvent({
                    Eventtype,
                    username1,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                }, gymid);
                await trackButtonClick("FlexibleCancellationPolicy", "Update_CancellationPolicy", "staff", {});
            } else {
                setApiError(true);
            }
        } catch (error) {
            console.error("Error updating Terms and Conditions:", error);
            setApiError(true);
        } finally {
            setIsSaving(false);
        }
        toggleShow(false);
    };

    const handleCancel = () => toggleShow(false);

    return (
        <div className="flexible-cancellation-policy">
            <MDBRow>
                <MDBCol md="12">
                    <MDBCard className="mb-4">
                        <MDBCardBody>
                            <div>
                                <div className="mb-3">
                                    <label className="form-label"> Title </label>
                                    <MDBInput
                                        value={formData.title}
                                        onChange={(e) => handleInputChange('title', e.target.value)}
                                        invalid={!!errors.title}
                                        required
                                        placeholder="Enter title"
                                    />
                                    {errors.title && (
                                        <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                            <MDBIcon fas icon="exclamation-triangle" className="me-1" />
                                            {errors.title}
                                        </div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Content</label>
                                    <ReactQuill
                                        value={formData.details}
                                        onChange={(value) => handleInputChange('details', value)}
                                    />
                                    {errors.details && (
                                        <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                            <MDBIcon fas icon="exclamation-triangle" className="me-1" />
                                            {errors.details}
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer pb-0">
                                    <MDBBtn color="secondary" onClick={handleCancel} disabled={isSaving}>
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn color="primary" onClick={onSaveButton} disabled={isSaving}>
                                        Save
                                    </MDBBtn>
                                </div>
                            </div>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </div>
    );
}

export default FlexibleCancellationPolicy;
